import { Component, Input, ViewChild } from '@angular/core';
import { BottomSheetListParams, IBottomSheetComponent } from '@m4u-angular/core/framework/bottom-sheet.service';
import { BottomSheetDialogComponent } from '@m4u-angular/ui/dialogs/bottom-sheet-dialog/bottom-sheet-dialog.component';
import { DxListComponent } from 'devextreme-angular';

@Component({
    selector: 'app-bottom-sheet-list',
    templateUrl: './bottom-sheet-list.component.html',
    styleUrls: ['./bottom-sheet-list.component.scss']
})
export class BottomSheetListComponent implements IBottomSheetComponent {
    @Input() ListParams: BottomSheetListParams;
    @ViewChild('list') list: DxListComponent;

    Context: BottomSheetDialogComponent;
    get IsGrouped(): boolean {
        const data = Array.isArray(this.ListParams.DataSource) ? this.ListParams.DataSource : (this.ListParams.DataSource as any).items();
        return data.some(x => x.key && x.items);
    }

    FilteredDataSource: any[];

    constructor() {
    }

    OnItemClick(e) {
        if (this.ListParams.IsMultiSelection) return;

        const selectedValue = e.itemData[this.ListParams.ValueExpr];
        this.CompleteSelection(e?.event, selectedValue);
    }

    ApplySelection(e) {
        const selectedValue = this.list.selectedItemKeys;
        this.CompleteSelection(e?.event, selectedValue);
    }

    private CompleteSelection(event, selectedValue) {
        if (this.Context)
            this.Context.OnClose() && this.Context.CloseDialogWithSuccess({ event: event, value: selectedValue });
        else
            this.ListParams.OnCompleted({ event: event, value: selectedValue });
    }

    GetBankIcon = (iconName: string) => {
        return `assets/projects/kraken/${iconName}`;
    };

    GetItemText = (data) => {
        return data.key
            || (typeof (this.ListParams.DisplayExpr) === 'function' ? this.ListParams.DisplayExpr(data) : data[this.ListParams.DisplayExpr]);
    };

    OnSearch(e) {
        const dataSource = this.ListParams.DataSource as any;
        if (!Array.isArray(dataSource)) {
            const filter = this.ListParams.SearchExpr
                .map(expr => [expr, 'contains', e])
                .reduce((acc, curr) => acc.length === 0 ? [curr] : [...acc, 'or', curr], []);
            dataSource.filter(filter);
            dataSource.load();
            return;
        }
        const originalDataSource = this.ListParams.DataSource as any[];
        this.FilteredDataSource = e.length
            ? originalDataSource.filter(x => this.ListParams.SearchExpr.some(expr => {
                return x[expr] ? x[expr].toLowerCase().includes(e.toLowerCase()) : false
            }))
            : undefined;
    }
}
